import RoutesMap from '../../../route_control/RouteControl.js'
import { Form, InputGroup, Button, Card } from 'react-bootstrap'
import { useFormik } from 'formik'
import { LoginSchema } from './ValidationSchema'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { KeyRound, UserRound, Eye, EyeOff, ArrowRight, Leaf } from 'lucide-react'
import logo from '../../../assets/images/Alexa logo (3).png'
import alexa_circle from '../../../assets/images/Alexa logo (3).png'
import ButtonLoader from '../../loader/ButtonLoader'
import SessionManager from '../../../utils/sessionManager.js'
import { signIn } from '../../../redux/slices/assets/SignIn'
import { sidebar } from '../../../redux/slices/assets/Sidebar'

export const LoginFormImport = {
    RoutesMap,
    Form,
    InputGroup,
    Button,
    Card,
    useFormik,
    LoginSchema,
    useNavigate,
    useDispatch,
    toast,
    KeyRound,
    UserRound,
    Eye,
    EyeOff,
    ArrowRight,
    Leaf,
    logo,
    alexa_circle,
    ButtonLoader,
    SessionManager,
    signIn,
    sidebar,
}